/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Cart App Tier
 * This is to provide all the cart related operations at cart app tier.
 *
 * The version of the OpenAPI document: v2
 * Contact: Pankaj.Gautam@Amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AccountType = {
    Employee: 'EMPLOYEE',
    MemberPlus: 'MEMBER_PLUS',
    Member: 'MEMBER',
    Customer: 'CUSTOMER',
    BusinessOwner: 'BUSINESS_OWNER'
} as const;
export type AccountType = typeof AccountType[keyof typeof AccountType];


export function AccountTypeFromJSON(json: any): AccountType {
    return AccountTypeFromJSONTyped(json, false);
}

export function AccountTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountType {
    return json as AccountType;
}

export function AccountTypeToJSON(value?: AccountType | null): any {
    return value as any;
}

